import addClientIpHeader from 'utils/addClientIpHeader';
import addCustomUserAgentHeader from 'utils/addCustomUserAgentHeader';
import addGeoCountryCodeHeader from 'utils/addGeoCountryCodeHeader';
import baseFetch, { createParamString } from '../baseFetch';

export const fetchRegionalOverview = ({
  clientIp,
  cookies,
  countryCode,
  includeLineupCams = false,
  includeInternalCams = false,
  subregionId,
}: {
  clientIp?: string | null;
  cookies?: Record<string, string>;
  countryCode?: string | null;
  includeLineupCams?: boolean;
  includeInternalCams?: boolean;
  subregionId: string;
}) => {
  const clientIpHeader = addClientIpHeader({ clientIp });
  const countryCodeHeader = addGeoCountryCodeHeader({ countryCode });

  const queryParams: Record<string, any> = {
    subregionId,
    ...(includeLineupCams && { includeLineupCams: true }),
    ...(includeInternalCams && { includeInternalCams: true }),
  };

  return baseFetch(`/kbyg/regions/overview?${createParamString(queryParams)}`, {
    cookies,
    headers: {
      ...clientIpHeader,
      ...countryCodeHeader,
    } as HeadersInit,
  });
};

export const fetchRegionalConditionForecast = (subregionId: string, days: number) =>
  baseFetch(`/kbyg/regions/forecasts/conditions?${createParamString({ subregionId, days })}`);

export const fetchNearbySubregions = (subregionId: string, cookies: Record<string, string>) =>
  baseFetch(`/kbyg/regions/nearby?${createParamString({ subregionId })}`, {
    cookies,
  });

export const fetchFavoriteSubregions = (cookies: Record<string, string>) =>
  baseFetch('/kbyg/favorites/subregions?', { cookies });

export const fetchForecasterContent = ({
  cookies,
  days = 16,
  subregionId,
}: {
  cookies: Record<string, string>;
  days?: number;
  subregionId: string;
}) =>
  baseFetch(`/kbyg/forecast-content?${createParamString({ days, subregionId })}`, {
    cookies,
  });

export const fetchRegionalArticles = async (
  subregionId: string,
  cookies: Record<string, string>,
  isServer: boolean = false,
  noCache: boolean = false,
) => {
  let cacheEnabled = true;
  const headers: Record<string, string> = {};
  if (noCache) {
    headers['Cache-Control'] = 'no-cache';
    cacheEnabled = false;
  }
  return baseFetch(`/feed/regional?${createParamString({ subregionId, cacheEnabled })}`, {
    cookies,
    headers: {
      ...headers,
      ...addCustomUserAgentHeader(isServer),
    },
  });
};
